var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "21", height: "16", viewBox: "0 0 21 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "Sensors"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "a", d: "M0 0h13v13H0z" }),
      React.createElement("path", { id: "c", d: "M0 0h13v13H0z" }),
      React.createElement("path", { id: "e", d: "M0 0h13v13H0z" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M2.8 0h8.4A2.8 2.8 0 0 1 14 2.8v8.4a2.8 2.8 0 0 1-2.8 2.8H2.8A2.8 2.8 0 0 1 0 11.2V2.8A2.8 2.8 0 0 1 2.8 0zM7 8.4a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8z" }),
      React.createElement("path", { d: "M7 15.321c3.51 0 6.3-2.164 6.3-4.75 0-2.094-12.6-2.094-12.6 0 0 2.586 2.79 4.75 6.3 4.75zM7 16c-3.866 0-7-2.216-7-4.95 0-2.733 14-2.733 14 0C14 13.784 10.866 16 7 16z" }),
      React.createElement(
        "g",
        { transform: "rotate(-45 12.414 -.95)" },
        React.createElement(
          "mask",
          { id: "b", fill: "#fff" },
          React.createElement("use", { xlinkHref: "#a" })
        ),
        React.createElement("path", { d: "M13 19.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zm0 .722a7.222 7.222 0 1 1 0-14.444 7.222 7.222 0 0 1 0 14.444z", mask: "url(#b)" })
      ),
      React.createElement(
        "g",
        { transform: "rotate(-45 12.414 -.95)" },
        React.createElement(
          "mask",
          { id: "d", fill: "#fff" },
          React.createElement("use", { xlinkHref: "#c" })
        ),
        React.createElement("path", { d: "M13 18.056a5.056 5.056 0 1 0 0-10.112 5.056 5.056 0 0 0 0 10.112zm0 .722a5.778 5.778 0 1 1 0-11.556 5.778 5.778 0 0 1 0 11.556z", mask: "url(#d)" })
      ),
      React.createElement(
        "g",
        { transform: "rotate(-45 12.414 -.95)" },
        React.createElement(
          "mask",
          { id: "f", fill: "#fff" },
          React.createElement("use", { xlinkHref: "#e" })
        ),
        React.createElement("path", { d: "M13 16.611a3.611 3.611 0 1 0 0-7.222 3.611 3.611 0 0 0 0 7.222zm0 .722a4.333 4.333 0 1 1 0-8.666 4.333 4.333 0 0 1 0 8.666z", mask: "url(#f)" })
      )
    )
  );
});